import { ApiProperty } from "@nestjs/swagger";
import {
  DriverStatus,
  RoleEnum,
} from "@project-management-system/shared-models";

export class DriverDto {
  @ApiProperty()
  id: number;

  @ApiProperty()
  name: string;

  @ApiProperty()
  lastName: string;

  @ApiProperty()
  dateOfBirth: Date;

  @ApiProperty()
  profileImage: string;

  // @ApiProperty()
  // file: string;

  // @ApiProperty()
  // fileList: string;

  @ApiProperty()
  profileImagePath: string;

  @ApiProperty()
  email: string;

  @ApiProperty()
  phoneNumber: number;
  @ApiProperty()
  plantId: number;

  @ApiProperty()
  address: string;

  @ApiProperty()
  state: string;

  @ApiProperty()
  city: string;

  @ApiProperty()
  userType: string;

  @ApiProperty()
  licenceNumber: string;

  @ApiProperty()
  licenceClass: string;

  @ApiProperty()
  licenceState: string;

  @ApiProperty()
  isActive: boolean;

  @ApiProperty()
  createdAt: Date;

  @ApiProperty()
  createdUser: string | null;

  @ApiProperty()
  updatedAt: Date;

  @ApiProperty()
  updatedUser: string | null;

  @ApiProperty()
  versionFlag: number;

  @ApiProperty()
  status: RoleEnum;

  @ApiProperty()
  driverStatus: DriverStatus;
}
